module.exports = "<uch></uch>\r\n<head-title params='title:\"应用排序\"'></head-title>\r\n<app-sort></app-sort>";


//////////////////
// WEBPACK FOOTER
// ./src/component/appSort/appSortIndex.html
// module id = 252
// module chunks = 0